import { JSEncrypt } from 'jsencrypt';

// 设置公钥
var publicKey =  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQVosAmSJ9Q6AyY7pObG2Ew34NcUgBzt+7Q4XSAeyuFw8r5HyuV+hcpniCFMmWwEn7k1LgnkC+ymPBV73gIBl5CMIxo7+wU4FtEsbAD0I68I5ZyWLi6cImj5tkWa2ON8Gp250zgMGBBs5KX2cX6MwiGauZtNkXAXqOQtXq7unNNQIDAQAB";

// 加密
function encryptText(text) {
  const instance = new JSEncrypt();
  instance.setPublicKey(publicKey);
  return instance.encrypt(text);
}

export {
  encryptText,
}
